import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

export var Item = /*#__PURE__*/_styled("li", true ? {
  target: "evn4hw50"
} : {
  target: "evn4hw50",
  label: "Item"
})(true ? {
  name: "11t2w6r",
  styles: "padding:6px 20px"
} : {
  name: "11t2w6r",
  styles: "padding:6px 20px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbi9EZXNrdG9wTmF2aWdhdGlvbi9TdXBwb3J0TGluay9TdXBwb3J0TGluay52aWV3cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFNkIiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9OYXZpZ2F0aW9uL0Rlc2t0b3BOYXZpZ2F0aW9uL1N1cHBvcnRMaW5rL1N1cHBvcnRMaW5rLnZpZXdzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmV4cG9ydCBjb25zdCBJdGVtID0gc3R5bGVkLmxpYFxuICBwYWRkaW5nOiA2cHggMjBweDtcbmBcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});